<template>
  <div class="crumbs-box">
    <div class="crumbs-box-l">
      <!-- <i class="el-icon-s-home"></i> -->
      <div class="crumbs-style">
        <span class="gray">当前位置:</span>
        <span @click="goMainPage()" class="gray">首页</span>
        <span class="gray">/</span>
        <span @click="goPage()">{{ firstText }}</span>
        <span v-if="thirdShow">/</span>
        <span v-if="thirdShow">{{ thirText }}</span>
        <span class="return-list" @click="goPage" v-if="goList">返回列表</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstUrl: String,
    firstText: String,
    thirText: String,
    thirdShow: {
      default: false,
      type: Boolean,
    },
    goList: {
      default: true,
      typr: Boolean,
    },
    goGuide: {
      default: false,
      typr: Boolean,
    },
  },
  methods: {
    goMainPage() {
      if (this.goGuide) {
        window.showedHeader = false;
      } else {
        window.showedHeader = true;
      }
      this.$router.push("./");
    },
    goPage() {
      if (this.goGuide) {
        window.showedHeader = false;
      } else {
        window.showedHeader = true;
      }
      // if (!this.thirdShow) return;
      this.$router.push(this.firstUrl);
    },
  },
};
</script>

<style>
.gray{
  color: #999999 ;
}
.crumbs-box {
  /* background: #f7f7f7; */
  width: 100%;
}
.crumbs-box-l {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
}
.crumbs-box span {
  font-size: 14px;
  /* margin-right: 10px; */
  cursor: pointer;
  padding: 5px 5px;
  display: inline-block;
}
.crumbs-box-l > i {
  float: left;
  color: #cdcdcd;
  font-size: 24px;
  margin-top: 21px;
}
.crumbs-style {
  box-sizing: border-box;
  padding: 16px;
  margin-top: 20px;
  padding-left: 20px;
}
.crumbs-style > span:nth-child(3),
.crumbs-style > span:nth-child(5),
.crumbs-style > span:nth-child(7) {
  cursor: pointer;
}
.crumbs-style > span:nth-child(7) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 250px; */
  display: inline-block;
  vertical-align: text-bottom;
}
.crumbs-style > .return-list {
  display: inline-block;
  float: right;
  text-align: center;
  padding: 5px 10px;
  background: #fff;
  border: 1px solid #cdcdcd;
}
@media screen and (max-width: 1200px) {
  .crumbs-box {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 767px) {
  .crumbs-style > span:nth-child(7) {
    margin-top: 2px;
  }
  .crumbs-style {
    padding: 10px;
    padding-right: 0px;
  }
  .crumbs-box {
    padding: 0 15px;
  }
  .crumbs-box span {
    font-size: 12px;
    margin-right: 0px;
    padding: 5px 3px;
  }
  .crumbs-box-l > i {
    font-size: 19px;
    margin-top: 8px;
  }
  .crumbs-style > .return-list {
    padding: 2px 5px;
  }
  .crumbs-style {
    padding: 5px 10px;
    padding-right: 0px;
  }
}
</style>